// extracted by mini-css-extract-plugin
export default {"card-image":"Upload_card-image__yLKMn","upload":"Upload_upload__OzpVR","upload-container":"Upload_upload-container__DCuel"};